<mat-form-field
  class="filter"
  style="width: 100%"
>
  <input
    #filter
    matInput
    [(ngModel)]="filterString"
    [value]="filterString()"
    type="search"
    [placeholder]="placeHolderText()"
    autocomplete="off"
  />
  @if (filterString()) {
    <button
      matSuffix
      matIconButton
      aria-label="Clear"
      (click)="filterString.set('')"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  @if (showScanner()) {
    <button
      mat-icon-button
      matSuffix
      (click)="openScannerDialog()"
      [attr.aria-label]="'Barcode Scanner'"
    >
      <mat-icon>qr_code_scanner</mat-icon>
    </button>
  }
</mat-form-field>
